import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Avatar,
    Box,
    Card,
    CardContent,
    Chip,
    ClickAwayListener,
    Divider,
    Grid,
    InputAdornment,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    OutlinedInput,
    Paper,
    Popper,
    Stack,
    Switch,
    Typography
} from '@mui/material';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import Transitions from 'ui-component/extended/Transitions';
import UpgradePlanCard from './UpgradePlanCard';
import useAuth from 'hooks/useAuth';
import User1 from 'assets/images/users/user-round.svg';

// assets
import { IconLogout, IconSearch, IconSettings, IconUser } from '@tabler/icons';
import useConfig from 'hooks/useConfig';
import LocalizationSection from '../LocalizationSection';
import { AccountCircleOutlined, Logout } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';

// ==============================|| PROFILE MENU ||============================== //

const ProfileMenu = () => {
    const theme = useTheme();
    const { borderRadius } = useConfig();
    const { logout } = useAuth();
    const location = useLocation();
    
    /**
     * anchorRef is used on different components and specifying one type leads to other components throwing an error
     * */
   // const anchorRef = useRef<any>(null);
    const handleLogout = async () => {
        try {
            await logout();
        } catch (err) {
            console.error(err);
        }
    };
   
   const isSelected = () => {
   
   if(location.pathname.split('/').indexOf('account-profile') >= 0){
   return true;
   }
   return false;
   };
    // const prevOpen = useRef(open);
    // useEffect(() => {
    //     if (prevOpen.current === true && open === false) {
    //         anchorRef.current.focus();
    //     }

    //     prevOpen.current = open;
    // }, [open]);

    return (
        <>   
           
                    
                {/* {user && user.name && (
                    <Box sx={{ p: 2, pb: 0 }}>
                        <Stack>
                            <Stack direction="row" spacing={0.5} alignItems="center">
                                <Typography component="span" variant="h4" sx={{ fontWeight: 400 }}>
                                    {user?.name}
                                </Typography>
                            </Stack>
                        </Stack>
                        <Divider />
                    </Box>
                )}

                <PerfectScrollbar style={{ height: '100%', maxHeight: 'calc(100vh - 250px)', overflowX: 'hidden' }}>
                <Box sx={{ px: 2, py: 0 }}>
                    <Divider /> */}
                    <List
                        component="nav"
                        sx={{
                            width: '100%',
                            py:0,
                            minWidth: 200,
                            maxWidth: 280,
                            backgroundColor: theme.palette.background.paper,
                            borderRadius: '10px',
                            [theme.breakpoints.down('md')]: {
                                minWidth: '100%'
                            },
                            '& .MuiListItemButton-root': {
                                px:3,
                                borderRadius: `${borderRadius}px`,
                                '& .MuiListItemIcon-root': {
                                    my: 'auto', 
                                    minWidth: 36,
                                    fontSize:1.5,
                                    color:'inherit !important'
                                }
                            },
                        }}
                    >
                        {/* <ListItemButton component="a" href='/user/account-profile/profile2' 
                            sx={{  }}
                            selected={isSelected()}
                                
                          //  onClick={handleLogout}
                        >
                            <ListItemIcon><AccountCircleOutlined  /></ListItemIcon>
                            <ListItemText  primary={
                            <Grid container>
                                 <Typography color="textPrimary">
                                    <FormattedMessage id="User Profile" />
                                    
                                    </Typography>
                            </Grid>
                        }/> 

                           
                        </ListItemButton> */}
                        <ListItemButton
                            sx={{  }}
                          //  selected={selectedIndex === 4}
                            onClick={handleLogout}
                        >
                            <ListItemIcon><Logout  /></ListItemIcon>
                            <ListItemText  primary={
                            <Grid container>
                                 <Typography color="textPrimary">
                                 <FormattedMessage id="Logout" />
                                    </Typography>
                            </Grid>
                        }/>

                           
                        </ListItemButton>
                    </List>
                {/* </Box>
                </PerfectScrollbar> */}
            
        </>
    );
};

export default ProfileMenu;
